/**
 *
 * @deprecated Use ShoppingList.getListItemElement() (typescript) instead
 * @param element
 * @returns {*|jQuery}
 */
window.getListItemElement = function getListItemElement(element) {
    return $(element).closest('[data-identifier]');
}

/**
 * Get list element for a list item element
 *
 * @deprecated Use ShoppingList.getListSummaryElement() (typescript) instead
 * @param list
 * @returns {jQuery}
 */
window.getListSummaryElement = function getListSummaryElement(list) {
    return $(list).find('.shopping-list-totals');
}

/**
 * Get list summary element for a list item element
 *
 * @deprecated Use ShoppingList.getShoppingList() (typescript) instead
 * @param listItem
 * @returns {jQuery}
 */
window.getListElement = function getListElement(listItem) {
    return $(listItem).data('list-ref')
        ? $('[data-list-id=' + $(listItem).data('list-ref') + '][data-removelink]:first')
        : $(listItem).closest('[data-removelink]');
}
